import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import BoardModal from "@board/components/board/BoardModal.vue";
import { LoadingBar } from '@appbase/components/loading'
import NoData from '@webparts/components/common/NoData.vue'
import WebpartBase from '@webparts/components/webparts/base/WebpartBase'
import WebpartTemplate from '@webparts/components/webparts/base/WebpartTemplate.vue'
import TabHead from '@webparts/components/webparts/YASKAWA/Board/TabHead.vue'
import SummaryList from '@webparts/components/webparts/YASKAWA/Board/SummaryList.vue'

import api from '@webparts/api';
import menuHelper from '@appbase/util/menu-helper'
import { IEDate, uGetDateFormat } from '@appbase/util'
import * as boardTypes from '@board/store/types'
import { open, OpenType } from '@board/open-handler';
import { loadScript } from '@appbase/util/script-loader'

const tempData = [{
  createdDate : new Date(),
  title : '신규직원 입사',
},{
  createdDate : '2022-10-28',
  title : '전보발령'
},{
  createdDate : '2022-10-16',
  title : '조직개편, 전보 및 보직발령',
},{
  createdDate : '2022-10-02',
  title : '주재원 파견발령',
},{
  createdDate : '2022-09-25',
  title : '전보발령 및 사간이동',
},{
  createdDate : '2022-09-03',
  title : '신규직원 입사',
},{
  createdDate : '2022-10-28',
  title : '전보발령'
},{
  createdDate : '2022-10-16',
  title : '조직개편, 전보 및 보직발령',
},{
  createdDate : '2022-10-02',
  title : '주재원 파견발령',
},{
  createdDate : '2022-09-25',
  title : '전보발령 및 사간이동',
},{
  createdDate : '2022-09-03',
  title : '신규직원 입사',
}]


@Component({
  name: 'articleboard-webpart',
  components: {
    LoadingBar,
    NoData,
    WebpartTemplate,
    TabHead,
    SummaryList
  },
  computed: mapGetters({
    popupBaseUrl: boardTypes.POPUP_BASEURL,
  }),
})
export default class BoardArticleWebpart extends Mixins(WebpartBase) {
  @Prop({type: Object}) webpart !: webpartv3.Webpart

  popupBaseUrl!: string;

  articles: webpartBoard.WebpartArticle[] = []
  boardId : number = 0
  page : number =1
  itemsPerPage: number =5
  options : any=null
  imagePath : string =""
  includeContent:boolean =false
  showImage:boolean = false

  get useTab(){
    return (this.webpart.props as any).useTab ?? false;
  }

  created() {
    if(this.webpart && this.webpart.props){
      this.setProps();
    }
    // 미리보기시 임시 데이터로 보여줌
    if(this.preview){
      // this.showImage = true;
      this.articles = (tempData as any).slice(0,this.itemsPerPage)
    }
    else {
      if ((window as any).eumBoardIds) {
      } else {
        loadScript('/cm/gres/js/boardFieldSetting.js', 'eum-board-setting', function () {
        })
      }
      this.load()
    }
  }

  // 웹파트 옵션 저장값 set
  setProps(){
    this.options = typeof(this.webpart.props) == typeof('') ? JSON.parse(this.webpart.props as string) : this.webpart.props;
    this.boardId = this.options.prop[0].boardId;
    this.itemsPerPage = this.options.prop[0].displayCount;
    this.includeContent = this.options.prop[0].includeContent;
    this.showImage = this.options.prop[0].showImage;
  }

  handleClick(artic : article.WebpartArticle) {
    if (this.preview) return

    if(this.isTeams){
      const modal: appbase.IModalOpenable = this.$refs['modal'] as any
      const options: appbase.TModalInfo<any> = {
        component: BoardModal,
        props: {boardId: artic.boardId, articleId: artic.articleId, title: artic.title},
        events: {
          cancel: () => {
            modal.closeModal()
          },
        },
      }
      modal.openModal(options)
    }
    else{
      open(OpenType.PopupRead,
          {
            boardId: artic.boardId,
            articleId: artic.articleId,
            baseUrl: this.popupBaseUrl
          });
    }
  }

  async load(){
    this.loading = true
    await api.board.getWebpartArticles({
      targetBoards: [ this.boardId ],
      itemsPerPage: this.itemsPerPage,
      page: this.page,
      includeContent: this.includeContent
    }).then(res=>{
      this.articles = res.data
      this.getImagePath()
    })
    this.loading = false
  }

  tabChange(val:any){
    this.showImage = val.showImage
    this.includeContent = val.includeContent
    this.boardId = val.boardId
    this.itemsPerPage = val.displayCount
    this.page=1
    this.load()
  }

  showNewIcon(article: article.Article) {
    var oneDay = 1000 * 60 * 60 * 24;
    var createdDate = new Date(article.createdDate);
    var today = new Date();

    var timeSpan = today.getTime() - createdDate.getTime();

    return timeSpan <= oneDay;
  }

  convertDate(val: Date){
    return uGetDateFormat('yyyy-MM-DD', IEDate(val))
  }

  moveTo(){
    if (this.preview) return
    let menu = menuHelper.findOneBySysId(this.boardId, 'BB')
    if(!menu) menu = menuHelper.findOneBySysId(this.boardId,'GF')
    if (menu) {
      menuHelper.next(menu)
    }
  }

  getClass(boardId:number, prefaceId:string){
    let returnClass = 's-blue'
    if((window as any).eumBoardIds){
      let prefaceOpt = (window as any).eumBoardIds.prefaceDefaultImage.filter((i:any)=>i.boardId==boardId && i.prefaceId==prefaceId)[0]
      if(prefaceOpt && prefaceOpt.color) returnClass = prefaceOpt.color;
    }

    return returnClass;
  }

  getImagePath(){
    // 기본 이미지
    // 00000 : default
    var img =`/cm/gres/faux/images/portal/etc_Thumb.png`;

    // 미리보기시 고정 이미지
    if(this.preview) img = '/cm/gres/faux/images/portal/img-news1.png';

    else if(this.articles && this.articles.length>0){
      // 본문에 이미지 있는 경우
      if(this.articles[0].imageFilePath) img = `/cm/Portal/Article/api/thumbnail?fileName=${this.articles[0].imageFilePath}`
      else {
        // 본문에 이미지 없는 경우 기본이미지로 설정
        if(this.articles[0].prefaceId){
          let prefaceOpt = (window as any).eumBoardIds.prefaceDefaultImage.filter((i:any)=>i.prefaceId==this.articles[0].prefaceId && i.boardId==this.articles[0].boardId)[0]
          if(prefaceOpt&&prefaceOpt.filename)
            img = `/cm/gres/faux/images/portal/${prefaceOpt.filename}`;
        }
      }
    }
    this.imagePath = img;
  }

  @Watch('webpart.props')
  changeWebpartValue(){
    this.setProps();
  }

  @Watch('itemsPerPage')
  changedItemsPerPageValue(val:number){
    if(this.preview){
      this.articles = (tempData as any).slice(0,this.itemsPerPage)
    }
  }
}
